module.exports = __webpack_public_path__ + "media/images/children-home-72fdbd3000211135d53c8352774a3b0a.jpg";